import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Robin Smith",
        title: "Manager",
        biography: "Robin Smith is an experienced Manager overseeing daily operations and team coordination. With a strong background in project management and customer relations, Robin ensures smooth workflows and excellent service delivery across all departments.",
        contacts: {
            experience: "10 years",
            phone: "333-444-5566",
            email: "robin.smith@example.com",
            website: "www.robinsmithmanagement.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Project Coordination",
            "Team Leadership",
            "Customer Service Management",
            "Operational Efficiency",
            "Process Improvement"
        ],
        specialties: [
            { id: 1, title: "Project Management", progress: 90 },
            { id: 2, title: "Team Leadership", progress: 88 },
            { id: 3, title: "Customer Relations", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "David Bairstow",
        title: "Assistant Manager",
        biography: "David Bairstow supports the management team by handling day-to-day administrative tasks and coordinating between departments. Known for his attention to detail and problem-solving skills, he ensures smooth operations and effective communication.",
        contacts: {
            experience: "7 years",
            phone: "444-555-6677",
            email: "david.bairstow@example.com",
            website: "www.davidbairstowassist.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Administrative Support",
            "Team Coordination",
            "Communication Management",
            "Problem Solving",
            "Operational Assistance"
        ],
        specialties: [
            { id: 1, title: "Administration", progress: 85 },
            { id: 2, title: "Coordination", progress: 87 },
            { id: 3, title: "Communication", progress: 83 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Barry Wood",
        title: "Director",
        biography: "Barry Wood oversees the strategic direction of the company, ensuring alignment with business goals and market trends. With extensive leadership experience, he drives innovation and growth across all departments.",
        contacts: {
            experience: "18 years",
            phone: "555-666-7788",
            email: "barry.wood@example.com",
            website: "www.barrywooddirector.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Strategic Planning",
            "Business Leadership",
            "Project Management",
            "Innovation Development",
            "Market Analysis"
        ],
        specialties: [
            { id: 1, title: "Strategy", progress: 95 },
            { id: 2, title: "Leadership", progress: 93 },
            { id: 3, title: "Project Management", progress: 90 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "John Snow",
        title: "Technician",
        biography: "John Snow is a skilled technician responsible for the installation, maintenance, and repair of solar energy systems. His technical expertise ensures reliable and efficient performance for all client projects.",
        contacts: {
            experience: "7 years",
            phone: "444-555-6677",
            email: "john.snow@example.com",
            website: "www.johnsnowtech.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "System Installation",
            "Technical Support",
            "Maintenance & Repairs",
            "Troubleshooting",
            "Client Training"
        ],
        specialties: [
            { id: 1, title: "Solar Systems", progress: 90 },
            { id: 2, title: "Troubleshooting", progress: 88 },
            { id: 3, title: "Customer Support", progress: 85 }
        ]
    }

];

export default team;